const RELOAD_FLAG = "syb_reload"

//设置刷新标识
export function setReloadFlag() {
    localStorage.setItem(RELOAD_FLAG, 1)
}

//设置刷新标识
export function getAndClearReloadFlag() {
    let _res = localStorage.getItem(RELOAD_FLAG)
    localStorage.removeItem(RELOAD_FLAG)
    return _res || false
}